import $ from 'jquery';

export default function scrollDownOnClick() {
    $(document).on('click', '#ume-scroll-down', function (event) {
        event.preventDefault();
        let viewportHeight = $(window).height();
        $('html, body').animate({
            scrollTop: viewportHeight,
            complete: function () {
                //Hide your button here
            }
        }, 1000);
    });
}
